import { Box, Link, Paper, Typography } from '@material-ui/core';
import React, { FC } from 'react';


const News: FC = () => {
  return (
    <Box height="100%" maxWidth="100%" display="grid">
      <Paper>
        <Box width="100%" px={2} py={2}>
          <Typography variant="h5">Что нового?</Typography>
          <Box width="100%" mt={1}>
          <Box color="secondary">
              <p>
                <b>20.05.2024</b>
              </p>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                Теперь доступно обновление до версии 3.0.1 для всех платформ 
              </Typography>
              <Typography color="primary">
                В Apple AppStore  можно обновить приложение до актуальной версии
                3.0.1.
              </Typography>
              <Typography color="primary">
                С сайта sneg.chernogolovka.com можно обновить приложение до
                3.0.1. по ссылке выше.
              </Typography>
            </Box>
            <Box color="secondary">
              <p>
                <b>01.03.2023</b>
              </p>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                Теперь доступно обновление до версии 1.2.32 для платформы IOS.
              </Typography>
              <Typography color="primary">
                В AppStore можно обновить приложение до актуальной версии
                1.2.32.
              </Typography>
            </Box>
            <Box color="secondary">
              <p>
                <b>30.01.2023</b>
              </p>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                Теперь в функционале Сканирование ХО для привязки точки к ХО
                есть возможность отобрать точки только для конкретного
                дистрибьютора.
              </Typography>
              <Typography color="primary">
                В форме изменения ТТ для ХО появилось поле Фильтр по
                дистрибьютору.
              </Typography>
              <Typography color="textSecondary">
                Данный фильтр призван ускорить и упростить нахождение верной ТТ.
              </Typography>
            </Box>
            <Box color="secondary">
              <p>
                <b>12.12.2022</b>
              </p>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                Теперь в приложении есть отчет о персональной активности{' '}
              </Typography>
              <Typography color="primary">
                В меню: Отчеты ➜ Отчет о персональной активности
              </Typography>
              <Typography color="textSecondary">
                Данный отчет позволяет осуществлять мониторинг собственной
                активности в приложении за заданный период .
              </Typography>
            </Box>
            <Box color="secondary">
              <p>
                <b>01.11.2022</b>
              </p>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                Теперь в приложении только один функционал по сканированию ХО{' '}
              </Typography>
              <Typography color="primary">В меню: Сканирование ХО </Typography>
              <Typography color="textSecondary">
                Процесс начинается с сканирования QR размещенного на ХО с
                последующей сверкой данных и фотографированием.
              </Typography>
              <Typography color="textSecondary">
                Пункты меню{' '}
                <strong>
                  &quot;Сканирование QR&quot;, &quot;Найдено ХО&quot;, &quot;Инвентаризация ХО&quot; и &quot;Визит
                  в ТТ ➜ Инвентаризация ТО&quot;
                </strong>{' '}
                убраны.
              </Typography>
            </Box>
            <Box color="secondary">
              <p>
                <b>15.09.2022</b>
              </p>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                1. Добавлен новый функционал по сканированию ХО{' '}
              </Typography>
              <Typography color="textSecondary">
                В меню: Торговое оборудование ➜ Инвентаризация ХО{' '}
              </Typography>
              <Typography color="textSecondary">
                Сканирование с помощью данного функционала можно сделать зная
                только серийный номер ХО. Необходимо использовать данный
                функционал для проведения регулярных сканирований.
              </Typography>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                2. Добавлены данные по параметрам ХО и планограммы.
              </Typography>
              <Typography color="textSecondary">
                В меню: Справочники ➜ Справочник ТО{' '}
              </Typography>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                3. Обновлена подсистема отправки данных из приложения, передача
                осуществляется частями, и в случае низкого качества связи и
                отключения от сети интернет - отправка приостанавливается и
                возобновляется при восстановлении соединения, что позволяет
                избегать &quot;потерь&quot; данных.
              </Typography>
            </Box>
            <Box color="secondary">
              <p>
                <b>15.05.2022</b>
              </p>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                1. Теперь есть раздел с формой{' '}
                <Link href="/help/feedback">обратной связи</Link>{' '}
              </Typography>
              <Typography color="textSecondary">
                В меню: Помощь ➜ Задать вопрос{' '}
              </Typography>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                2. В визите при заведении нового ХО появились подсказки по вводу
                серийного номера для различных моделей оборудования.
              </Typography>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                3. Выводятся предупреждения при сканировании ХО если
                отсканированнй QR не действительный или оборудование с таким QR
                находится по другому адресу.
              </Typography>
            </Box>
            <Box pl={2} pb={1}>
              <Typography color="textPrimary">
                4. При выходе из активности визита, например &quot;Инвентаризации
                ХО&quot;, визит не завершается (но данные будут отправлены).
              </Typography>
              <Typography color="textSecondary">
                И можно продолжить визит другой активностью, например
                &quot;Размещение стоек&quot;.
              </Typography>
            </Box>
            <Box color="secondary">
              <p>
                <b>25.04.2022</b>
              </p>
            </Box>
            <Box pl={2}>
              <Typography>
                В &quot;Визит в ТТ&quot; добавлено визуальное отображения количества
                оборудования размещенного в точке:
              </Typography>
              <Box display="flex" mb={1}>
                <img src="/images/2022-04-27_13-46.png" />
                <Box ml={1}>
                  <Box mt={2}>
                    - количество холодильного оборудования;
                    <br />
                  </Box>
                  <Box marginTop={3}>- количество стоек;</Box>
                </Box>
              </Box>
              <Box>
                <Box mb={1} whiteSpace="">
                  При поиске точки так же можно увидеть иконки в выпадающем
                  списке:
                </Box>
                <img width="100%" src="/images/2022-04-27_13-45.png" />
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default News;
